export const getFailedTransferCutoffIso = () =>
  new Date(Date.now() - 48 * 60 * 60 * 1000).toISOString();

/**
 * A Verification ticket becomes fail-to-transfer only when it is still "ToBeVerified"
 * and its timestamp is known to be older than the 48h cutoff.
 * Missing/invalid timestamps should not hide brand-new tickets from the Verification tab.
 */
export const isFailToTransferTicketLike = (
  status: string | null | undefined,
  updatedAt: string | null | undefined,
  cutoffIso = getFailedTransferCutoffIso(),
): boolean => {
  if ((status || '') !== 'ToBeVerified') return false;

  const cutoffTs = Date.parse(cutoffIso);
  if (!Number.isFinite(cutoffTs)) return false;

  const updatedAtTs = Date.parse(updatedAt || '');
  if (!Number.isFinite(updatedAtTs)) {
    return false;
  }
  return updatedAtTs <= cutoffTs;
};

export type FailToTransferManageTicket = {
  tp_status?: string | null;
  tp_updated_at?: string | null;
};

export const isFailToTransferTicket = (
  ticket: FailToTransferManageTicket,
  cutoffIso = getFailedTransferCutoffIso(),
): boolean => isFailToTransferTicketLike(ticket.tp_status, ticket.tp_updated_at, cutoffIso);
